// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
//  引入babel-polyfill  解决axios的兼容性问题
import 'babel-polyfill'
import * as actions from './store/actions'
import state from './store/state'
import mutations from './store/mutations'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import echarts from 'echarts';
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false
Vue.use(Vuex);
Vue.use(Element);

let store = new Vuex.Store({
    actions,
    state,
    mutations
})


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js